export const CANVA_OAUTH_SCOPES = ['design:content:read', 'design:meta:read', 'folder:read'];
